import { UserSquareForm } from "components/UserSquareForm";
import Target from "../../assets/target.svg";
import TargetEdit from "../../assets/target-edit.svg";
import { useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SnackBarComponent } from "components/SnackBarComponent";
import { BubbleProfile } from "components/BubbleProfile";
import { updateUser } from "services/updateUser";
import { UserDataContext } from "context/UserDataContext";
import { CoursesContext } from "context/coursesContext";

const schema = yup.object({
  email: yup.string().email().required(),
  direccionCompleta: yup.string(),
  telefono: yup.string(),
});

const initialSnackBar = {
  message: "",
  isSnackbarOpen: false,
  severity: "success",
};

export const UserSquare = () => {
  const { userData: user, getUserInfo } = useContext(UserDataContext);
  const { userPlan } = useContext(CoursesContext);
  const [snackBarInfo, setSnackBarInfo] = useState(initialSnackBar);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: {
      email: user.email,
      direccionCompleta: user.direccionCompleta,
      telefono: user.telefono,
    },
    resolver: yupResolver(schema),
  });

  const handleClose = () => {
    setSnackBarInfo({ ...initialSnackBar, isSnackbarOpen: false });
  };

  const onSubmit = async (data) => {
    setSnackBarInfo({
      ...initialSnackBar,
      isSnackbarOpen: true,
      message: "Guardando...",
      autoHideDuration: 2000,
    });
    const res = await updateUser({ ...user, ...data });
    if (!res.ok)
      return setSnackBarInfo({
        ...initialSnackBar,
        isSnackbarOpen: true,
        message: "Ha ocurrido un error al actualizar",
        severity: "error",
      });
    setSnackBarInfo({
      ...initialSnackBar,
      isSnackbarOpen: true,
      message: "Informacion actualizada correctamente",
    });
    getUserInfo();
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      for (const error of Object.keys(errors)) {
        setSnackBarInfo({
          ...initialSnackBar,
          message: errors[error].message,
          severity: "error",
          isSnackbarOpen: true,
        });
      }
    }
  }, [errors]);

  const isFlexiblePlan = userPlan.nombre === "Flexible";
  return (
    <div
      className={`grid grid-cols-1 ${
        isFlexiblePlan ? "grid-rows-3" : "grid-rows-2"
      } lg:grid-cols-2 ${
        isFlexiblePlan ? "lg:grid-rows-2" : "lg:grid-rows-1"
      } gap-4 bg-primary lg:max-w-[35%] max-h-[350px] justify-center items-center rounded-xl lg:py-10 px-2.5`}
    >
      <div className="flex flex-col justify-self-center">
        <BubbleProfile {...user} />
      </div>
      <div className="flex flex-col items-center">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col gap-4 items-center
          "
        >
          <h3 className="w-full user-name-h3 text-center">{user.nombre}</h3>
          <p className="occupation-user ">{user.ocupacion}</p>
          <p className="location-user">
            <label className="flex gap-2">
              {user.direccionCompleta.length <= 0 ? (
                <img src={TargetEdit} className="target-icon" alt="user-icon" />
              ) : (
                <img src={Target} className="target-icon" alt="user-icon" />
              )}
              <input
                className="input-card max-w-[90%]"
                {...register("direccionCompleta")}
              />
            </label>
          </p>
          <label className="label-card">
            Email
            <input
              type="email"
              className="input-card label-user-input"
              {...register("email")}
            />
          </label>
          <label className="label-card">
            Phone
            <input
              type="text"
              className="input-card label-user-input"
              {...register("telefono")}
            />
          </label>
        </form>
      </div>
      <div className="flex flex-col lg:col-span-2 lg:row-start-2 items-center justify-center gap-4 mt-4">
        {isFlexiblePlan && (
          <>
            <div className="w-6/12 border-t border-white opacity-40"></div>
            <p className="text-white text-center text-sm sm:text-base">
              Need a break? You can cancel your plan anytime.
            </p>
            <a
              href="https://wa.link/dr1a08"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-300 hover:text-blue-400 underline underline-offset-2 transition duration-200 text-sm sm:text-base"
            >
              End my plan
            </a>
          </>
        )}
      </div>
      <SnackBarComponent handleClose={handleClose} {...snackBarInfo} />
    </div>
  );
};
